import { render, staticRenderFns } from "./purchaseStockReturn-add-or-update.vue?vue&type=template&id=23f42aed&scoped=true"
import script from "./purchaseStockReturn-add-or-update.vue?vue&type=script&lang=js"
export * from "./purchaseStockReturn-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./purchaseStockReturn-add-or-update.vue?vue&type=style&index=0&id=23f42aed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f42aed",
  null
  
)

export default component.exports